import { Box } from '@mui/material'
import { useThemeMode } from '../../../theme'

export const ApplicationBackground = () => {
  const { palette } = useThemeMode()

  const sx = {
    backgroundImage: {
      maxWidth: '100%',
      width: '100%',
      height: '100%',
      position: 'fixed',
      top: '0',
      zIndex: '-100',
      backgroundColor: palette.disabledOverlay,
      backgroundPosition: '30% top',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundImage:
        'url(https://www.cesfur.org/css/gfx-cesfur/2026/background-lg.jpg)',
      '@media screen and (max-width: 700px)': {
        backgroundImage:
          'url(https://www.cesfur.org/css/gfx-cesfur/2026/background-md.jpg)',
        backgroundPosition: 'right top'
      }
    }
  }

  return (<Box sx={sx.backgroundImage}></Box>)
}
